import OrganizationMemberUpdate from '@/screens/OrganizationMemberUpdate';

export default function PrivateOrganizationOrganizationIdMemberPersonIdEditIndexRoute() {
  return <OrganizationMemberUpdate />;
}
